export default "__VITE_ASSET__E8Ky33tC__"